import { Location } from 'react-router-dom';
import { TeamPageTabKey, TeamPageTabKeys } from './types';
import { TeamMemberResponse } from 'store/teams/types';

export const getActiveTeamPageTabKey = (location: Location) => {
    const stateKey = (location.state as { activeTabKey?: TeamPageTabKey })?.activeTabKey;

    if (stateKey && Object.values(TeamPageTabKeys).includes(stateKey)) {
        return stateKey;
    }

    const segments = location.pathname.split('/');
    const potentialTabKey = segments[3] as TeamPageTabKey;

    if (Object.values(TeamPageTabKeys).includes(potentialTabKey)) {
        return potentialTabKey;
    }

    return TeamPageTabKeys.MANIFESTS;
};

export const getTeamManagersLabel = (teamManagers: TeamMemberResponse[]) => {
    const [firstManager, ...otherManagers] = teamManagers;
    const othersCount = otherManagers.length;
    const label =
        othersCount > 0
            ? `${firstManager.individual.fullName} (+${othersCount} other${othersCount > 1 ? 's' : ''})`
            : firstManager.individual.fullName;

    return label;
};
